'use client'

import { Divider } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import ProNavBar from '../../components/ProNavBar'

import Hero from './Hero'
import MobileHero from './MobileHero'
import Convincing from './Convincing'
import OtherDetails from './OtherDetails'
import Faq from './Faq'
import Banner from './Banner'
import Footer from './Footer'
import ProIntegrations from './ProIntegrations'

type Props = {
  isDigitalLawEnabled: boolean
  isBusinessInfoLinksEnabled: boolean
  onlineComplaintUrl?: string
}

const BusinessAccountsHomepage = ({
  isDigitalLawEnabled,
  isBusinessInfoLinksEnabled,
  onlineComplaintUrl,
}: Props) => {
  const isProIntegrationsPageEnabled = useFeatureSwitch('pro_integrations_page_enabled')

  return (
    <>
      <ProNavBar showRightButtons />
      <Hero />
      <div className="container">
        <MobileHero />
        <Convincing />
        <Divider />
        <OtherDetails />
      </div>
      {isProIntegrationsPageEnabled ? (
        <>
          <ProIntegrations />
          <div className="container">
            <Faq />
          </div>
        </>
      ) : (
        <div className="container">
          <Divider />
          <Faq />
        </div>
      )}

      <Banner />
      <Footer
        isDigitalLawEnabled={isDigitalLawEnabled}
        isBusinessInfoLinksEnabled={isBusinessInfoLinksEnabled}
        onlineComplaintUrl={onlineComplaintUrl}
      />
    </>
  )
}

export default BusinessAccountsHomepage
